export const FETCH_CONVERSATION_RAW_EMAIL =
  'rawEmails/FETCH_CONVERSATION_RAW_EMAIL'
export const FETCH_CONVERSATION_RAW_EMAIL_STARTED =
  'rawEmails/FETCH_CONVERSATION_RAW_EMAIL_STARTED'
export const FETCH_CONVERSATION_RAW_EMAIL_SUCCESS =
  'rawEmails/FETCH_CONVERSATION_RAW_EMAIL_SUCCESS'
export const FETCH_CONVERSATION_RAW_EMAIL_FAILED =
  'rawEmails/FETCH_CONVERSATION_EVENT_GROUPS_FAILED'
